var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.$slots),function(_,slotName){return [_vm._t(slotName)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }